"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkInstance = void 0;

var Utils_1 = require("../../../Utils");

var LinkInstance = /*#__PURE__*/function () {
  function LinkInstance(container) {
    _classCallCheck(this, LinkInstance);

    this.container = container;
  }

  _createClass(LinkInstance, [{
    key: "particleCreated",
    value: function particleCreated(particle) {
      var linkParticle = particle;
      linkParticle.links = [];
    }
  }, {
    key: "particleDestroyed",
    value: function particleDestroyed(particle) {
      var linkParticle = particle;
      linkParticle.links = [];
    }
  }, {
    key: "drawParticle",
    value: function drawParticle(context, particle) {
      var _this = this;

      var linkParticle = particle;
      var container = this.container;
      var particles = container.particles;
      var pOptions = particle.options;

      if (linkParticle.links.length > 0) {
        context.save();
        var p1Links = linkParticle.links.filter(function (l) {
          var linkFreq = container.particles.getLinkFrequency(linkParticle, l.destination);
          return linkFreq <= pOptions.links.frequency;
        });

        var _iterator = _createForOfIteratorHelper(p1Links),
            _step;

        try {
          var _loop = function _loop() {
            var link = _step.value;
            var p2 = link.destination;

            if (pOptions.links.triangles.enable) {
              var links = p1Links.map(function (l) {
                return l.destination;
              });
              var vertices = p2.links.filter(function (t) {
                var linkFreq = container.particles.getLinkFrequency(p2, t.destination);
                return linkFreq <= p2.options.links.frequency && links.indexOf(t.destination) >= 0;
              });

              if (vertices.length) {
                var _iterator2 = _createForOfIteratorHelper(vertices),
                    _step2;

                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    var vertex = _step2.value;
                    var p3 = vertex.destination;
                    var triangleFreq = particles.getTriangleFrequency(linkParticle, p2, p3);

                    if (triangleFreq > pOptions.links.triangles.frequency) {
                      continue;
                    }

                    _this.drawLinkTriangle(linkParticle, link, vertex);
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
              }
            }

            if (link.opacity > 0 && container.retina.linksWidth > 0) {
              _this.drawLinkLine(linkParticle, link);
            }
          };

          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        context.restore();
      }
    }
  }, {
    key: "drawLinkTriangle",
    value: function drawLinkTriangle(p1, link1, link2) {
      var _a;

      var container = this.container;
      var options = container.actualOptions;
      var p2 = link1.destination;
      var p3 = link2.destination;
      var triangleOptions = p1.options.links.triangles;
      var opacityTriangle = (_a = triangleOptions.opacity) !== null && _a !== void 0 ? _a : (link1.opacity + link2.opacity) / 2;

      if (opacityTriangle <= 0) {
        return;
      }

      var pos1 = p1.getPosition();
      var pos2 = p2.getPosition();
      var pos3 = p3.getPosition();
      container.canvas.draw(function (ctx) {
        if ((0, Utils_1.getDistance)(pos1, pos2) > container.retina.linksDistance || (0, Utils_1.getDistance)(pos3, pos2) > container.retina.linksDistance || (0, Utils_1.getDistance)(pos3, pos1) > container.retina.linksDistance) {
          return;
        }

        var colorTriangle = (0, Utils_1.colorToRgb)(triangleOptions.color);

        if (!colorTriangle) {
          var linksOptions = p1.options.links;
          var linkColor = linksOptions.id !== undefined ? container.particles.linksColors.get(linksOptions.id) : container.particles.linksColor;
          colorTriangle = (0, Utils_1.getLinkColor)(p1, p2, linkColor);
        }

        if (!colorTriangle) {
          return;
        }

        (0, Utils_1.drawLinkTriangle)(ctx, pos1, pos2, pos3, options.backgroundMask.enable, options.backgroundMask.composite, colorTriangle, opacityTriangle);
      });
    }
  }, {
    key: "drawLinkLine",
    value: function drawLinkLine(p1, link) {
      var container = this.container;
      var options = container.actualOptions;
      var p2 = link.destination;
      var opacity = link.opacity;
      var pos1 = p1.getPosition();
      var pos2 = p2.getPosition();
      container.canvas.draw(function (ctx) {
        var _a, _b;

        var colorLine;
        var twinkle = p1.options.twinkle.lines;

        if (twinkle.enable) {
          var twinkleFreq = twinkle.frequency;
          var twinkleRgb = (0, Utils_1.colorToRgb)(twinkle.color);
          var twinkling = Math.random() < twinkleFreq;

          if (twinkling && twinkleRgb !== undefined) {
            colorLine = twinkleRgb;
            opacity = twinkle.opacity;
          }
        }

        if (!colorLine) {
          var linksOptions = p1.options.links;
          var linkColor = linksOptions.id !== undefined ? container.particles.linksColors.get(linksOptions.id) : container.particles.linksColor;
          colorLine = (0, Utils_1.getLinkColor)(p1, p2, linkColor);
        }

        if (!colorLine) {
          return;
        }

        var width = (_a = p1.retina.linksWidth) !== null && _a !== void 0 ? _a : container.retina.linksWidth;
        var maxDistance = (_b = p1.retina.linksDistance) !== null && _b !== void 0 ? _b : container.retina.linksDistance;
        (0, Utils_1.drawLinkLine)(ctx, width, pos1, pos2, maxDistance, container.canvas.size, p1.options.links.warp, options.backgroundMask.enable, options.backgroundMask.composite, colorLine, opacity, p1.options.links.shadow);
      });
    }
  }]);

  return LinkInstance;
}();

exports.LinkInstance = LinkInstance;